<template>
  <div class="android-apps">
    <div class="wrap-row-column !tw-flex">
      <div
        v-if="isSubAffiliate"
        class="select-wrapper !tw-w-full mobile:!tw-mb-16"
      >
        <UiSelect
          v-model="subAffiliateId"
          :label="$t('mediaBuying.campaign.affiliate')"
          :placeholder="$t('mediaBuying.campaign.my_account')"
          :list="referrals"
          is-search
          @change="changeSubAffiliateId"
        />
      </div>
      <div
        class="!tw-w-full ml-16 mobile:!tw-mb-16"
        :class="{ 'ml-0': !isSubAffiliate }"
      >
        <UiSelect
          v-model="offerId"
          :label="$t('androidApp.offer')"
          :placeholder="$t('promoCodes.addPromocodes.selectOffer')"
          :list="offersOption"
          is-search
          class="mb-16"
        />
      </div>
    </div>
    <UiSelect
      v-model="brandId"
      :label="$t('androidApp.brand')"
      :placeholder="$t('profile.generalInfo.notSpecified')"
      :list="brandsOption"
      :disabled="!offerId"
      is-search
      class="mb-16"
    />
    <UiSelect
      v-model="trafficSourceId"
      class="mb-16"
      :label="$t('trafficSources.trafficSource')"
      :placeholder="$t('profile.generalInfo.notSpecified')"
      :list="trafficSourceList"
      :disabled="!brandId"
      is-search
      @change="changeSource"
    />
    <div class="row row-wrap__subid">
      <div
        v-for="(item, i) in subIds"
        :key="i"
        class="mb-16 col-6 col-6__add-subid"
      >
        <ElPopover
          v-if="i === 0"
          ref="popover"
          v-model:visible="warningOpen"
          placement="top-start"
          trigger="click"
          width="320"
        >
          <p>{{ $t('promoCodes.addPromocodes.changeSubId') }}</p>
          <button
            class="btn btn-outline-primary btn-md"
            @click="warningOpen = false"
          >
            {{ $t('offerRequest.btnCancel') }}
          </button>
          <button
            class="btn btn-primary btn-md !tw-ml-1rem"
            @click="confirmChanges(); warningOpen = false"
          >
            {{ $t('offerRequest.btnConfirm') }}
          </button>

          <template v-slot:reference>
            <div class="subIdPopover" />
          </template>
        </ElPopover>

        <UiInputSubid
          v-model="item.value"
          :label="`SubID ${subIds.indexOf(item) + 1}`"
          :placeholder="$t('trafficSources.postbacks.notSpecified')"
          :disabled="!brandId"
          :can-delete="subIds.indexOf(item) === subIds.length - 1 && subIds.length > 1"
          @delete="popSubIds"
        />
      </div>
      <div class="col-6 !tw-flex !tw-items-end col-6__add-subid">
        <button
          :disabled="subIds.length >= 5 || !brandId"
          href="#"
          class="btn btn-block btn-outline-primary btn-sm mb-16"
          @click.prevent="subIds.length < 5 && addSubId()"
        >
          + {{ $t('promoCodes.addPromocodes.addAnotherSubid') }}
        </button>
      </div>
    </div>
    <UiSelect
      v-model="app"
      :label="$t('androidApp.selectApp')"
      :placeholder="$t('profile.generalInfo.notSpecified')"
      :list="appsOption"
      :disabled="!offerId || !brandId"
      is-search
      class="mb-16"
    />
    <a
      v-loading="isLoading"
      class="btn btn-primary btn-md !tw-w-full confirm-btn"
      :class="{ disabled: !downloadLink }"
      :href="downloadLink"
      target="_blank"
    >
      <UiIcon
        name="download-icon"
        :size="12"
        class="btn-icon download-icon ui-m-sm-r"
      />
      {{ $t('androidApp.downloadApp') }}
    </a>
  </div>
</template>

<script>
import _ from '@/lib/lodash';

export default {
  components: {},
  mixins: [],
  props: {
    mediaBuyingCampaignId: {
      type: String,
      default: null,
    },
    isSubAffiliate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      brandId: null,
      brands: [],
      app: null,
      apps: [],
      offerId: null,
      subAffiliateId: null,
      isLoading: false,
      trafficSourceId: null,
      subIds: [{ value: null }],
      warningOpen: false,
      downloadLink: '',
      errors_: {},
      oldValue: null,
    };
  },
  computed: {
    referrals() {
      return this.$store.state.subaffiliates.all.map((e) => ({
        id: e.data.id,
        text: e.email,
      })).concat({ id: '', text: this.$t('mediaBuying.campaign.my_account') });
    },
    trafficSourceList() {
      return this.$store.state.trafficSource.list.map((e) => ({
        id: e.data.id,
        text: e.name,
      }))
        .concat({
          id: '',
          text: this.$t('offerRequest.noTrafficSources'),
        });
    },

    offersOption() {
      return [
        ...this.$store.state.offers.my.map((el) => ({
          id: el.id,
          text: el.name,
        })),
      ];
    },
    appsOption() {
      return [
        ...this.apps.map((el) => ({
          id: el.id,
          text: el.name,
        })),
      ];
    },
    brandsOption() {
      return [
        ...this.brands.map((el) => ({
          id: el.site_id,
          text: el.site_name,
        })),
      ];
    },
  },
  mounted() {
    this.$store.dispatch('getAffiliateOffers');
    this.$store.dispatch('getTrafficSources', {});
  },
  watch: {
    $route(to) {
      if (to.name === 'routes.androidApps') {
        this.resetData();
        this.$store.dispatch('getTrafficSources', {});
      } else if (this.warningOpen) {
        this.warningOpen = false;
      }
    },
    brandId(val) {
      this.app = null;
      this.downloadLink = '';
      this.errors_ = {};

      if (val) {
        this.$api.getMobileApps({ affiliate_offer_id: this.offerId, site_id: val }).then((res) => {
          this.apps = res.payload;
        }).catch((e) => {
          this.errors_ = e.response.data.errors;
        });
      }
    },
    offerId(val) {
      this.brandId = null;

      if (val) {
        this.$api.getAffiliateOffer(val).then((res) => {
          this.brands = res.payload.visible_brands;
        });
      }
    },
    trafficSourceId() {
      this.app = null;
      this.downloadLink = '';
    },
    subIds: {
      deep: true,
      handler() {
        this.app = null;
        this.downloadLink = '';
      },
    },
    app(id) {
      if (!id) return;

      const subIdObj = this.subIds.reduce((acc, { value }, i) => {
        acc[`subid${parseInt(i) + 1}`] = value;
        return acc;
      }, {});

      const app = this.apps.find((el) => el.id === id);
      this.isLoading = true;
      this.$api.downloadApp(id, {
        affiliate_offer_id: this.offerId,
        site_id: app.site_id,
        ...(this.trafficSourceId && {
          traffic_source_id: this.trafficSourceId,
        }),
        ...(this.mediaBuyingCampaignId && {
          media_buying_campaign_id: this.mediaBuyingCampaignId,
        }),
        ...subIdObj,
      })
        .then((res) => this.downloadLink = res.data.payload.url)
        .finally(() => this.isLoading = false);
    },
  },
  methods: {
    resetData() {
      this.brandId = null;
      this.brands = [];
      this.app = null;
      this.apps = [];
      this.offerId = null;
      this.isLoading = false;
      this.downloadLink = '';
      this.subIds = [{ value: null }];
      this.trafficSourceId = '';
      this.warningOpen = false;
      this.errors_ = {};
      this.oldValue = null;
    },
    changeSubAffiliateId() {
      this.resetData();
      this.isLoading = true;

      const id = this.subAffiliateId ? { sub_affiliate_id: this.subAffiliateId } : {};
      const offers = this.$store.dispatch('getAffiliateOffers', id);
      const traffic = this.$store.dispatch('getTrafficSources', id);

      this.$store.dispatch('getMarketingCampaigns', id);
      Promise.all([offers, traffic])
        .then(() => {
          this.isLoading = false;
        });
    },
    changeSource(value) {
      if (!value) {
        // if no traffic source selected clear subIds
        this.subIds = [{ value: null }];
        return;
      }
      // subIds from ts
      let source = this.$store.state.trafficSource.list.filter((e) => e.data.id === value)[0];
      source = _.pick(source, ['subid1', 'subid2', 'subid3', 'subid4', 'subid5']);

      // subIds from old ts
      let oldSource = this.$store.state.trafficSource.list.filter((e) => e.data.id === this.oldValue)[0];
      oldSource = _.pick(oldSource, ['subid1', 'subid2', 'subid3', 'subid4', 'subid5']);

      // take current subIds
      const subIds = {};
      for (let i = 0; i < 5; i++) {
        const key = `subid${i + 1}`;
        subIds[key] = this.subIds[i] ? this.subIds[i].value : null;
      }

      const subIdObj = this.subIds.reduce((acc, { value }, i) => {
        acc[`subid${parseInt(i) + 1}`] = value;
        return acc;
      }, {});

      // if current subIds is equal with subIds from trafficsources
      if (_.isEmpty(oldSource) || _.isEqual(subIds, oldSource)) {
        this.addSubIds(source);
      } else if(!_.isEmpty(oldSource) && !_.isEqual(oldSource, subIdObj)) {
        // show warning
        this.warningOpen = true;
      }
      this.oldValue = value;
    },
    addSubIds(source) {
      if (!source) {
        this.subIds = [{ value: null }];
        return;
      }
      this.subIds = [];
      // Push subIds
      Object.keys(source).map((k) => {
        if (k.startsWith('subid')) {
          if (source[k]) {
            this.subIds.push({
              value: source[k],
            });
          } else {
            this.subIds.push({
              value: null,
            });
          }
        }
      });
      // reduce subIds
      for (let i = this.subIds.length - 1; i >= 1; i--) {
        if (!this.subIds[i].value) this.subIds.pop();
        else break;
      }
    },
    addSubId() {
      this.subIds.push({
        value: null,
      });
    },
    popSubIds() {
      this.subIds.pop();
    },
    confirmChanges() {
      this.subIds = [];
      const source = this.$store.state.trafficSource.list.filter((e) => e.data.id === this.trafficSourceId)[0];
      this.addSubIds(source);
    },
  },
};
</script>

<style lang="scss" scoped>
.android-apps {
  display: flex;
  flex-direction: column;

    .el-input {
      // /deep/ {
      // vue3-migration -- удаляем /deep/
      :deep(.select2-container) {
        z-index: 9999!important;
      }
      // }
    }

    .btn {
      border-radius: 8px !important;

      // /deep/ {
      // vue3-migration -- удаляем /deep/
      :deep(.ui-icon) {
        color: var(--color-text-primary) !important;
      }
      // }
    }

    .confirm-btn {
      display: flex;
      align-items: center;
      justify-content: center;

      height: 34px;
      font-size: 12px !important;
      font-weight: 600;
      text-transform: capitalize;

      &.disabled {
        filter: grayscale(100%);
      }
    }

    .row-wrap__subid {
      margin-top: 0;

      .subIdPopover {
        position: relative;
        top: 40px;
      }

      .col-6__add-subid {
        .form-group {
          margin-top: 26px !important;

          .btn-cross {
            top: initial;
            bottom: -3px;
          }
        }
      }
    }
  }
</style>
